import { logoDex } from "./Monedas";
import { useT } from "../lib/i18n";

/**
 * «DEX soportadas»: la banda de tranquilidad de la portada, calcada de la que enseñan otros bots
 * (myliquidbot) pero con las marcas que de verdad usamos —Uniswap, Robinhood, PRJX y PancakeSwap—,
 * cada una con su logo real del bundle, no un icono genérico.
 *
 * No dice «conecta tu exchange» porque aquí no se conecta ningún exchange: el dinero vive en TU
 * vault y nunca sale de él. Esa es la frase, y es la misma que ya está en el pie — repetirla donde
 * están los logos es donde más pesa.
 *
 * Los logos flotan en posiciones dispersas con un halo de su color de marca. El movimiento es puro
 * ambiente: se apaga entero con `prefers-reduced-motion` (ver styles.css) y ningún dato depende de él.
 */
// Repartidos por TODO el cuadro (esquinas y bandas), no agrupados a la derecha. Cada uno vaga con
// su propia duración/sentido (ver .dex-ficha:nth-child en styles.css), así se mueven por toda la caja.
const DEXS = [
  { marca: "UNISWAP",     nombre: "Uniswap",     color: "#ff007a", x: "58%", y: "15%", size: 72, delay: "0s" },
  { marca: "ROBINHOOD",   nombre: "Robinhood",   color: "#00c805", x: "86%", y: "30%", size: 62, delay: "1.4s" },
  { marca: "PRJX",        nombre: "PRJX",        color: "#e8b64b", x: "50%", y: "62%", size: 68, delay: "0.6s" },
  { marca: "PANCAKESWAP", nombre: "PancakeSwap", color: "#1fc7d4", x: "70%", y: "72%", size: 58, delay: "2.1s" },
  { marca: "AERODROME",   nombre: "Aerodrome",   color: "#2f6bff", x: "90%", y: "78%", size: 56, delay: "3s" },
] as const;

/** Con nombre y red: los logos solos no decían dónde se puede abrir un vault. Mismo reparto que
 *  `etiqueta` en config/networks.ts. */
const LISTA = [
  { marca: "UNISWAP",     nombre: "Uniswap",     redes: "Arbitrum · Ethereum" },
  { marca: "ROBINHOOD",   nombre: "Robinhood",   redes: "Robinhood Chain" },
  { marca: "AERODROME",   nombre: "Aerodrome",   redes: "Base" },
  { marca: "PANCAKESWAP", nombre: "PancakeSwap", redes: "BNB Chain" },
  { marca: "PRJX",        nombre: "PRJX",        redes: "HyperEVM" },
] as const;

export function DexSoportadas() {
  const t = useT();
  return (
    <section className="dexs">
      <div className="dexs-texto">
        <p className="rotulo">{t("Mercados soportados")}</p>
        <h2 className="dexs-titular">{t("DEX soportadas")}</h2>
        <p className="dexs-sub">{t("Elige tu DEX. Tu dinero nunca sale de tu vault.")}</p>
        <ul className="dexs-lista">
          {LISTA.map((d) => {
            const url = logoDex(d.marca);
            return (
              <li key={d.marca}>
                {url && <img src={url} alt="" width={22} height={22} loading="lazy" draggable={false} />}
                <b>{d.nombre}</b>
                <span>{d.redes}</span>
              </li>
            );
          })}
        </ul>
      </div>

      <div className="dexs-orbita">
        {DEXS.map((d) => {
          const url = logoDex(d.marca);
          return (
            <span
              key={d.marca}
              className="dex-ficha"
              title={d.nombre}
              style={{
                left: d.x,
                top: d.y,
                width: d.size,
                height: d.size,
                animationDelay: d.delay,
                ["--brillo" as string]: d.color,
              }}
            >
              {url
                ? <img src={url} alt={d.nombre} draggable={false} loading="lazy" />
                : <span className="dex-txt">{d.nombre}</span>}
            </span>
          );
        })}
      </div>
    </section>
  );
}
